(function () {
  function forEachNode(list, callback) {
    Array.prototype.forEach.call(list || [], callback);
  }

  function getHeaderOffset() {
    var fixedHeader = document.querySelector('#shopify-section-header');
    var siteHeader = document.querySelector('.site-header');
    var stickyHeader = document.querySelector('.header-sticky, .is-sticky .site-header, .sticky-wrapper .site-header');
    var activeHeader = fixedHeader || stickyHeader || siteHeader;
    var headerHeight = activeHeader ? activeHeader.getBoundingClientRect().height : 0;

    return Math.max(headerHeight + 24, 96);
  }

  function getScrollTopForTarget(target) {
    if (!target) return 0;

    return Math.max(
      target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset(),
      0
    );
  }

  function scrollTargetBelowHeader(target) {
    if (!target) return;

    target.style.scrollMarginTop = getHeaderOffset() + 'px';
    target.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  }

  function correctTargetOverlap(target) {
    if (!target) return;

    var desiredTop = getScrollTopForTarget(target);
    var currentTop = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (Math.abs(currentTop - desiredTop) <= 2) return;

    window.scrollTo({
      top: desiredTop,
      behavior: 'auto'
    });
  }

  function initHeroWidget(container) {
    if (!container || container.dataset.devHeroInitialized === 'true') return;

    var slider = container.querySelector('.hero-video-slider.hero-no-cls');
    if (!slider || typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick !== 'function') return;

    slider.setAttribute('data-dev-hero-managed', 'true');

    var $ = window.jQuery;
    var $hero = $(slider);
    if ($hero.hasClass('slick-initialized')) {
      container.dataset.devHeroInitialized = 'true';
      return;
    }

    var youtubeId = slider.getAttribute('data-yt') || container.getAttribute('data-yt') || 'YeVtbKN_zXU';
    var rotatingTarget = container.querySelector('[data-dev-hero-rotating]');
    var prevButton = container.querySelector('[data-dev-hero-prev]');
    var nextButton = container.querySelector('[data-dev-hero-next]');
    var rotatingWords = (container.getAttribute('data-dev-hero-rotating-words') || 'moldes|insumos|detalles|ideas')
      .split('|')
      .map(function (word) { return word.replace(/^\s+|\s+$/g, ''); })
      .filter(Boolean);

    var bootAt = Date.now();
    var lastResumeAt = 0;
    var resumeCooldownMs = 1800;
    var wentHidden = false;
    var iframeInjected = false;

    function shouldIgnoreResume() {
      var now = Date.now();
      if (now - bootAt < 800) return true;
      if (now - lastResumeAt < resumeCooldownMs) return true;
      lastResumeAt = now;
      return false;
    }

    function buildIframe() {
      if (iframeInjected) return;
      var slide = $hero.find('.hero-slide--youtube').first();
      if (!slide.length) return;

      var iframe = document.createElement('iframe');
      iframe.className = 'hero-video-iframe';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen', '1');
      iframe.src =
        'https://www.youtube.com/embed/' + encodeURIComponent(youtubeId) +
        '?enablejsapi=1&controls=0&fs=0&iv_load_policy=3&rel=0&showinfo=0' +
        '&loop=1&playlist=' + encodeURIComponent(youtubeId) +
        '&start=1&autoplay=1&mute=1&playsinline=1';

      slide.css('position', 'relative');
      slide.append(iframe);
      slide.addClass('has-video-iframe');
      iframeInjected = true;
    }

    function postMessageToPlayer(player, command) {
      if (!player || !command) return;
      try {
        player.contentWindow.postMessage(JSON.stringify(command), '*');
      } catch (error) {}
    }

    function playPauseHero(action) {
      var current = $hero.find('.slick-current');
      if (!current.length) return;

      var player = current.find('iframe.hero-video-iframe').get(0);
      if (!player) return;

      if (action === 'play') {
        postMessageToPlayer(player, { event: 'command', func: 'mute' });
        postMessageToPlayer(player, { event: 'command', func: 'playVideo' });
      } else {
        postMessageToPlayer(player, { event: 'command', func: 'pauseVideo' });
      }
    }

    function setDragging(state) {
      $hero.toggleClass('is-dragging', !!state);
    }

    function setButtonState(button, isDisabled) {
      if (!button) return;
      button.disabled = !!isDisabled;
      button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      button.classList.toggle('slick-disabled', !!isDisabled);
      button.tabIndex = isDisabled ? -1 : 0;
    }

    function syncArrowState(slick) {
      if (!slick || slick.options.infinite) {
        setButtonState(prevButton, false);
        setButtonState(nextButton, false);
        return;
      }

      var currentIndex = typeof slick.currentSlide === 'number' ? slick.currentSlide : 0;
      var lastIndex = Math.max((slick.slideCount || 1) - 1, 0);

      setButtonState(prevButton, currentIndex <= 0);
      setButtonState(nextButton, currentIndex >= lastIndex);
    }

    function resumeHero() {
      if (shouldIgnoreResume()) return;

      buildIframe();
      playPauseHero('play');

      if (!wentHidden) return;

      var iframe = $hero.find('.slick-current iframe.hero-video-iframe');
      if (iframe.length) {
        if (!iframe.attr('data-orig-src')) iframe.attr('data-orig-src', iframe.attr('src'));

        setTimeout(function () { playPauseHero('play'); }, 120);

        setTimeout(function () {
          iframe.attr('src', iframe.attr('data-orig-src'));
          setTimeout(function () { playPauseHero('play'); }, 350);
        }, 520);
      }

      wentHidden = false;
    }

    $hero.on('beforeChange', function () {
      setDragging(true);
      playPauseHero('pause');
    });

    $hero.on('afterChange', function (event, slick) {
      setDragging(false);
      syncArrowState(slick);
      if ($hero.find('.slick-current').hasClass('hero-slide--youtube')) resumeHero();
    });

    $hero.on('touchstart mousedown', function () {
      setDragging(true);
      playPauseHero('pause');
    });

    $hero.on('touchend mouseup mouseleave', function () {
      setDragging(false);
      if ($hero.find('.slick-current').hasClass('hero-slide--youtube')) resumeHero();
    });

    $hero.on('init reInit', function (event, slick) {
      syncArrowState(slick);
    });

    $hero.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: true,
      autoplay: false,
      speed: 600,
      adaptiveHeight: false,
      variableWidth: false,
      lazyLoad: 'ondemand',
      cssEase: 'cubic-bezier(0.87, 0.03, 0.41, 0.9)'
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        $hero.slick('slickPrev');
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        $hero.slick('slickNext');
      });
    }

    syncArrowState($hero.slick('getSlick'));

    forEachNode(container.querySelectorAll('[data-dev-hero-scroll-target]'), function (trigger) {
      trigger.addEventListener('click', function (event) {
        var selector =
          trigger.getAttribute('data-dev-hero-scroll-target') ||
          trigger.getAttribute('href') ||
          container.getAttribute('data-dev-hero-scroll-default');

        if (!selector || selector.charAt(0) !== '#') return;

        var target = document.querySelector(selector);
        if (!target) return;

        event.preventDefault();
        event.stopPropagation();

        scrollTargetBelowHeader(target);

        window.setTimeout(function () {
          correctTargetOverlap(target);
        }, 450);

        window.setTimeout(function () {
          correctTargetOverlap(target);
        }, 900);

        if (window.history && typeof window.history.replaceState === 'function') {
          window.history.replaceState(null, '', selector);
        }
      });
    });

    if (rotatingTarget && rotatingWords.length > 1 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var index = 0;
      rotatingTarget.style.transition = 'opacity 180ms ease, transform 180ms ease';
      window.setInterval(function () {
        index = (index + 1) % rotatingWords.length;
        rotatingTarget.style.opacity = '0';
        rotatingTarget.style.transform = 'translateY(6px)';

        setTimeout(function () {
          rotatingTarget.textContent = rotatingWords[index];
          rotatingTarget.style.opacity = '1';
          rotatingTarget.style.transform = 'translateY(0)';
        }, 180);
      }, 2200);
    }

    buildIframe();
    setTimeout(function () {
      if ($hero.find('.slick-current').hasClass('hero-slide--youtube')) playPauseHero('play');
    }, 250);

    setTimeout(function () {
      if ($hero.find('.slick-current').hasClass('hero-slide--youtube')) resumeHero();
    }, 900);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        wentHidden = true;
        return;
      }
      if ($hero.find('.slick-current').hasClass('hero-slide--youtube')) resumeHero();
    });

    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted) wentHidden = true;
      if ($hero.find('.slick-current').hasClass('hero-slide--youtube')) resumeHero();
    });

    container.dataset.devHeroInitialized = 'true';
  }

  function initAllHeroWidgets(root) {
    var scope = root && root.querySelectorAll ? root : document;
    forEachNode(scope.querySelectorAll('[data-dev-hero-widget]'), initHeroWidget);
  }

  window.initDevHeroWidget = initHeroWidget;
  window.initAllDevHeroWidgets = initAllHeroWidgets;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllHeroWidgets(document);
    });
  } else {
    initAllHeroWidgets(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllHeroWidgets(event && event.target ? event.target : document);
  });
})();
